import { createEffect} from '@ngrx/effects';
import { Actions, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import * as HouseholdActions from './household.actions';
import { inject } from '@angular/core';
import { HouseholdService } from '../../services/household.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';

export const loadHouseholds$ = createEffect(
  (
    actions$ = inject(Actions),
    householdService = inject(HouseholdService),
    notification = inject(NotificationService),
    translate = inject(TranslateService)
  ) =>
    actions$.pipe(
      ofType(HouseholdActions.loadHouseholds),
      mergeMap(() =>
        householdService.getUserHouseholds().pipe(
          map(households => {
            // Optional:
            // notification.success('Households loaded.');
            return HouseholdActions.loadHouseholdsSuccess({ households });
          }),
          catchError(error => {
            notification.error(translate.instant('household.notifications.loadFailure'));
            return of(HouseholdActions.loadHouseholdsFailure({ error }));
          })
        )
      )
    ),
  { functional: true }
);

export const HouseholdEffects = {
  loadHouseholds$
};
